new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.widget-kit').then(element => {
        const widgetCategory = element.querySelector('#widget-kit');
        if(widgetCategory) {
            $('#widget-kit').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: false,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            dots: false,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.product-slider').then(element => {
        let rotationVitrine = element.querySelector('.rotation-vitrine');
        if (rotationVitrine) {
            let rotationNames = rotationVitrine.querySelectorAll('.categories .categories__name');
            let initVitrine = rotationVitrine.querySelectorAll('.rotation-vitrine__products .item');
            initVitrine = Array.from(initVitrine);
        
            if(rotationVitrine && rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
        
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    $('#js-rotation-vitrine5, #js-rotation-vitrine4, #js-rotation-vitrine3, #js-rotation-vitrine2, #js-rotation-vitrine').slick('refresh').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        Blazy({
                            selector: '.lazy-img',
                            successClass: 'loaded-img',
                            success: function (element) {
                                setTimeout(function () {
                                    var parent = element.previousSibling;
                                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                                }, 100);
                            }
                        });
                    });
                }
        
                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                })
            }

            $('#js-rotation-vitrine, #js-rotation-vitrine2, #js-rotation-vitrine3, #js-rotation-vitrine4, #js-rotation-vitrine5').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 5,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.product-slider-2').then(element => {
        let rotationVitrine2 = element.querySelector('.rotation-vitrine-2');
        if (rotationVitrine2) {
            let rotationNames = rotationVitrine2.querySelectorAll('.categories2 .categories2__name');
            let initVitrine = rotationVitrine2.querySelectorAll('.rotation-vitrine-2__products .item');
            initVitrine = Array.from(initVitrine);
            const isMobile = window.innerWidth <= 991;
        
            if(rotationVitrine2 && rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
        
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });

                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    if (isMobile) {
                        $('#js-rotation-vitrine6, #js-rotation-vitrine7, #js-rotation-vitrine8').slick('refresh').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                            Blazy({
                                selector: '.lazy-img',
                                successClass: 'loaded-img',
                                success: function (element) {
                                    setTimeout(function () {
                                        var parent = element.previousSibling;
                                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                                    }, 100);
                                }
                            });
                        });
                    }

                    $(".product-item:not(.widget-loaded)").each(function (i, el) {
                        var el = $(el);
                        if (el.visible(true)) {
                          el.addClass("widget-loaded");
                          $(el).children().trigger("mouseenter");
                        } else {
                          //el.removeClass("visible");
                        }
                    });
                }
        
                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                })
            }

            if (isMobile) {
                $('#js-rotation-vitrine6, #js-rotation-vitrine7, #js-rotation-vitrine8').slick({
                    arrows: false,
                    dots: false,
                    infinite: false,
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 700,
            
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: "unslick"
                        }
                    ]
                });
            }
        }
    });

    $('.product-ratings-list').slick({
        arrows: true,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                }
            }
        ]
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list-3');
        if(firstCarrousel) {
            $('#product_list-3').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 577,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });
})

function copyElementContentToClipboard(event) {
    var clipboardElement = event.currentTarget;
    var clipboardContent = clipboardElement.textContent || clipboardElement.innerText;
    
    navigator.clipboard.writeText(clipboardContent).then(function() {
        clipboardElement.classList.add("copied");
        clipboardElement.textContent = "COPIADO!";
    }).catch(function(error) {
        console.error("Erro ao copiar para o clipboard:", error);
    });
}

// Adicionar o event listener ao elemento clipboard
document.getElementById("tc-coupon").addEventListener("click", copyElementContentToClipboard);